const textCopy = {
  init() {
    const sourceEl = document.querySelector(
      '#GDCategory .cat-main__total-showing'
    ) as HTMLElement | null;

    const targetEl = document.getElementById('jsCountWrap');

    if (!sourceEl || !targetEl) return;

    const updateCount = () => {
      const text = sourceEl.textContent || '';

      const match = text.match(/\d+/g);

      if (!match) return;

      console.log(sourceEl);
      const number = match[match.length - 1];

      targetEl.textContent = `(${number})`;
    };


    updateCount();

    const observer = new MutationObserver(updateCount);

    observer.observe(sourceEl, {
      childList: true,
      subtree: true,
      characterData: true,
    });
  },
};

export default textCopy;